import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { head } from 'lodash';

import { Grid } from 'web-ui-components/lib/layout/grids';

import { verificationPropTypes } from '../../states/payments/propTypes';
import IFTPaymentDetails from '../PaymentDetails/ifts/IFTPaymentDetails';
import LiveRateBox from '../LiveRateBox/LiveRateBox';
import {
	getExchangeRate,
	getFxChargeAmount,
	getPaymentAmounts,
	getNewSubmissionAndSettlementDates,
} from '../../states/rates/selectors';

import { CONST_AMOUNT_UPPERCASE } from '../../constants/Constants';

const mapState = (state) => ({
	exchangeRate: getExchangeRate(state),
	paymentAmounts: getPaymentAmounts(state),
	chargeAmount: getFxChargeAmount(state),
	newSubmissionAndSettlmentDates: getNewSubmissionAndSettlementDates(state),
});

export const AuthoriseIFTPayment = (props) => {
	const {
		toAuthorise,
		exchangeRate,
		paymentAmounts,
		chargeAmount,
		counter,
		showInitialGetRate,
		showRefresh,
		onRefresh,
		showExchangeRate,
		newSubmissionAndSettlmentDates: { newSettlementDate, newSubmissionDate } = {},
		isIFTPreBooked,
		isSameCurrencyPayment,
	} = props;
	const { payments, created_timestamp, final_approval } = toAuthorise;
	const firstPayment = head(payments);
	const { charge_amount, payment_amount } = firstPayment;
	const payment = {
		...firstPayment,
		final_approval,
		payment_amount: paymentAmounts.length ? paymentAmounts : payment_amount,
		created_timestamp,
		exchangeRate: showExchangeRate ? exchangeRate : undefined,
		value_date: newSettlementDate || firstPayment.value_date,
		submission_date: newSubmissionDate || firstPayment.submission_date,
		chargeAmount: chargeAmount || charge_amount.find((amount) => amount.type === CONST_AMOUNT_UPPERCASE),
	};
	return (
		<div className="u-margin-bottom-4 u-margin-top-3" id="authorise-ift-payment">
			{isIFTPreBooked || isSameCurrencyPayment ? (
				<Grid.TwoThirds>
					<IFTPaymentDetails payment={payment} />
				</Grid.TwoThirds>
			) : (
				<Grid.ThreeToOne
					rightSidebar={
						<LiveRateBox
							exchangeRate={exchangeRate}
							counter={counter}
							showExchangeRate={showExchangeRate}
							showInitialGetRate={showInitialGetRate}
							showRefresh={showRefresh}
							onRefresh={onRefresh}
						/>
					}
				>
					<IFTPaymentDetails payment={payment} />
				</Grid.ThreeToOne>
			)}
		</div>
	);
};

AuthoriseIFTPayment.propTypes = {
	exchangeRate: PropTypes.string,
	chargeAmount: PropTypes.shape({
		currency: PropTypes.string,
		value: PropTypes.string,
	}),
	paymentAmounts: PropTypes.arrayOf(
		PropTypes.shape({
			currency: PropTypes.string,
			value: PropTypes.string,
		})
	),
	counter: PropTypes.number.isRequired,
	showInitialGetRate: PropTypes.bool.isRequired,
	showRefresh: PropTypes.bool.isRequired,
	toAuthorise: PropTypes.shape(verificationPropTypes),
	onRefresh: PropTypes.func.isRequired,
	showExchangeRate: PropTypes.bool.isRequired,
	newSubmissionAndSettlmentDates: PropTypes.shape({
		newSettlementDate: PropTypes.string,
		newSubmissionDate: PropTypes.string,
	}),
	isIFTPreBooked: PropTypes.bool.isRequired,
	isSameCurrencyPayment: PropTypes.bool,
};

AuthoriseIFTPayment.defaultProps = {
	isSameCurrencyPayment: false,
};

export default connect(mapState)(AuthoriseIFTPayment);
